import React from 'react';
import { format } from 'date-fns';
import { AUIButtonCell } from '@ancert/aui-table-cell';
import { ESTADOS_DENUNCIA } from '../../lib/denuncia.enum';

const getColumns = (events, canViewId) => [
  {
    id: 'id',
    accessor: (row) => row.complaint,
    columnWidth: canViewId ? 80 : 280,
    header: 'ID',
    cell: ({ value }) => <>{canViewId ? value.id : value.publicId}</>,
  },
  {
    id: 'fecha',
    accessor: (row) => row.complaint.creationDate,
    columnWidth: 124,
    header: 'Fecha',
    cell: ({ value }) => <>{format(new Date(value), 'dd/MM/yyyy')}</>,
  },
  {
    id: 'status',
    accessor: (row) => row.complaint.status,
    header: 'Estado',
    cell: ({ value }) => <>{ESTADOS_DENUNCIA[value].desc}</>,
  },
  {
    id: 'action',
    columnWidth: 80,
    accessor: (row) => row.complaint,
    header: '',
    cell: ({ value }) => (
      <AUIButtonCell
        buttonList={[
          {
            mode: 'ghost',
            label: 'Ver',
            onClick: () => {
              events(value?.publicId);
            },
          },
        ]}
      />
    ),
  },
];

export default getColumns;
